import { Effect, Reducer } from 'umi';
import { unique } from '@/pages/dashboard/utils/utils';
import { RecentViewItemType } from '@/pages/dashboard/types/dashboard';
import { storage } from '@/utils/utils';
import { LOCAL_STROAGE_GAME_CODE_KEY } from '@dbl/core/global';
import { getCommonConfig, getGameList, getRecentViewd } from '@dbl/services/global';
import { formatSeasonInfo } from '@/pages/dashboard/models/_config/_utils';
import { isEmpty } from 'lodash-es';

export const namespace = 'datalab';

export interface DatalabModelStateType {
  showContentMask: boolean;
  leftMenuWidth: number;// 左侧菜单宽度
  rawGameList: Array<any>;
  gameList: Array<any>; // 游戏列表
  currentGame: null | object; // 当前选中的游戏
  gameCode: string; // 当前选中的游戏
  recentViewList: Array<RecentViewItemType>; // 最近浏览的游戏
  isExpendLeftMenu: boolean;
  gameConfig: Object;
  refreshIsNormal: boolean; // 强刷当前左侧目录
}

export interface DatalabModelType {
  namespace: string;
  state: DatalabModelStateType;
  effects: {
    getGameList: Effect;
    changeGame: Effect; // 切换游戏
    // getRecentViewd: Effect;
    getRecentAndFollowViewd: Effect;
    getCommonConfig: Effect;
    // getFollowViewd: Effect
    // batchSaveFollow: Effect
    // addFollowGame: Effect
    // addFollowBatchGame: Effect
    // removeFollowGame: Effect
  };
  reducers: {
    save: Reducer<DatalabModelStateType>;
  };
}

const DatalabModel: DatalabModelType = {
  namespace,

  state: {
    showContentMask: false,
    leftMenuWidth: 250,
    rawGameList: [],
    gameList: [],
    currentGame: null,
    gameCode: '',
    recentViewList: [],
    isExpendLeftMenu: true,
    refreshIsNormal: true,
    gameConfig: {},
  },

  effects: {

    // 获取游戏列表
    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    *getGameList({ payload }, { put, take, select }) {
      try {
        // @ts-ignore
        const result: any = yield getGameList();
        const { main_game: gameList = [] } = result;
        // eslint-disable-next-line no-nested-ternary
        !isEmpty(gameList) && gameList?.sort((a: { game_code: string; }, b: { game_code: string; }) => (a?.game_code === "databrain" ? -1 : b?.game_code === "databrain" ? 1 : 0));
        yield put({
          type: "save", payload: {
            // rawGameList: (gameList || []).filter((item: any) => item && item.game_code !== 'databrain'),
            // filter过滤 是产品特殊要求, 临时处理, 后期应该会去掉
            rawGameList: gameList || []
          }
        });
      } catch (e) {
        yield put({
          type: "save", payload: {
            rawGameList: [],
          }
        });
      }
    },

    // 切换游戏
    *changeGame({ payload, callback }, { put, select }) {
      const { gameCode } = payload;
      const { gameList = [] } = yield select((state: any) => state[namespace]) || {};
      const { userInfo = null } = yield select((state: any) => state.home) || {};
      const currentGame = findGame(gameCode, gameList);
      if (currentGame && userInfo) {
        storage.setItem(LOCAL_STROAGE_GAME_CODE_KEY, {
          userId: userInfo.userid,
          code: currentGame?.game_code,
        });
      }
      yield put({
        type: "save", payload: {
          currentGame,
          gameCode: currentGame?.game_code,
          menuList: null,
          folderList: [],
          dashboardList: [],
          customizedMetricsList: [],
          currentMenu: null
        }
      });
      callback?.();
    },
    // 获取游戏事件配置
    *getCommonConfig({ payload }, { put }) {
      const { gameCode } = payload;
      try {
        const result = yield getCommonConfig(gameCode);
        const seasonInfoResult = formatSeasonInfo(result?.season_info || { day: [], week: [], month: [] });
        yield put({
          type: "save",
          payload: {
            gameConfig: { ...result, season_info: seasonInfoResult, status: 'success' }
          }
        });
      } catch (error) {
        console.log(error);
      }
    },
    // 获取最近浏览和收藏的游戏
    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    *getRecentAndFollowViewd({ payload }, { put, select }) {
      const recentList = yield getRecentViewd();
      // const followList = yield getFollowViewd(payload);
      const followList = [];
      const { gameList } = yield select((state: any) => state[namespace]);
      const filterGameList = gameList?.map((game: any) => {
        const followTarget = followList?.find((followItem: any) => followItem.game_code === game.game_code);

        return {
          ...game,
          isFollow: Boolean(followTarget),
          followId: followTarget?.id,
          followSort: followTarget?.sort
        };
      });

      const nextFollowList = followList?.map((followGame: any) => (
        filterGameList?.find((game: any) => game.game_code === followGame.game_code)
      ))?.filter((game: any) => game?.isFollow);

      const nextRecentList = recentList?.map((recentGame: any) => (
        filterGameList?.find((game: any) => 
          // 用子版本的game_code做对比，不然顺序会有错误
          Boolean(game?.game_List?.find((item: any) => item.game_code === recentGame.game_code)) || game.game_code === recentGame.game_code
        )
      ))?.filter((item: any) => item); // filter 过滤掉不存在的游戏，后端数据可能有脏数据

      // 按照game_code去重
      yield put({
        type: "save", payload: {
          followList: nextFollowList,
          recentList: unique(nextRecentList, 'game_code'),
        }
      });

      // recent 或者 follow 有一项则可以展示我的游戏，否则跳转到所有游戏
      return nextFollowList?.length > 0 || nextRecentList?.length > 0;
    },
    // *batchSaveFollow({ payload }, { put, select }) {
    //   yield addFollowBatchGame({
    //     data: payload.data
    //   });
    //   const followList = yield getFollowViewd({
    //     game_code: payload.game_code
    //   });
    //   const { gameList } = yield select((state: any) => state[namespace]);
    //   const filterGameList = gameList?.map((game: any) => {
    //     const followTarget = followList?.find((followItem: any) => followItem.game_code === game.game_code)
    //     return {
    //       ...game,
    //       isFollow: Boolean(followTarget),
    //       followId: followTarget?.id,
    //       followSort: followTarget?.sort
    //     }
    //   })
    //
    //   // 批量更新完后及时更新收藏列表
    //   yield put({
    //     type: "save", payload: {
    //       followList: followList?.map((followGame: any) => (
    //         filterGameList?.find((game: any) => game.game_code === followGame.game_code)
    //       ))?.filter((game: any) => game && game?.isFollow)
    //     }
    //   });
    // },


  },
  reducers: {
    save(state: DatalabModelStateType, action: any) {
      return {
        ...state,
        ...action.payload,
      };
    },
  }
};

export default DatalabModel;

// 根据路由查询game
export const findGame = (gameCode: string, gameList: Array<any>): any => {
  let currentGame = null;
  gameList.some(item => {
    const { game_List: subGameList } = item;
    if (subGameList.length > 0) {
      // 先从子列表查找
      return subGameList.some((subItem: any) => {
        if ((gameCode && subItem?.game_code === gameCode) || (!gameCode && subItem?.is_access)) {
          currentGame = {
            ...subItem,
            // sameLevelList: subGameList
          };
          return true;
        }
        return false;
      });
    } 
    if ((gameCode && item?.game_code === gameCode) || (!gameCode && item?.is_access)) {
      currentGame = {
        ...item,
        // sameLevelList: subGameList
      };
      return true;
    }
    return false;
    
  });
  return currentGame || gameList?.[0]?.game_List?.[0] || gameList?.[0] || null;
};

